// Данные позиции каталога для предзаполнения формы заявки (ApplicationForm):
// когда онлайн-оформление позиции недоступно (не задан тип предмета лизинга),
// «Оформить онлайн» открывает заявку менеджеру уже с этой техникой
const CURRENCIES = { RUB: "Рубль", CNY: "Юань", USD: "Доллар", EUR: "Евро" };

const fromCatalogItem = (item) => ({
  PLName: item.name || "",
  PLBrand: item.brand || "",
  PLModel: item.model || "",
  PLPrice: item.price ? String(item.price) : "",
  currency: CURRENCIES[item.currency] || "Рубль",
  supplier: item.supplier_inn || "",
});

export { fromCatalogItem };
